import agencies from "./agencies";

export const AGENCY_NAMESPACE = "agencies";

export default agencies;
